//格式化为url参数 json拼接url
export function queryString(params = {}) {
  // return Reflect.ownKeys(params).map(key => params[key] && `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).filter(item => item).join('&');
  return Reflect.ownKeys(params).filter(item => params[item] !== undefined && params[item] !== '').map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
}